// src/pages/Moderation/UsersViolationsPage/ui/UsersViolationsTable/UsersViolationsRow.tsx
import React from 'react';
import { Link } from 'react-router-dom';

import { GetFlagsResponse } from 'redux/reducers/moderation/types';
import { base } from 'routes/ModerationRoutes';
import { decodeRestrictionValue } from 'untils/decodeRestrictions';
import { ModerationUser } from '../types';
import { formatUsername, restrictionsCount } from '../utils';

type Props = {
  user: ModerationUser;
  onClick?: () => void;
  flags: GetFlagsResponse | null;
};

export const UsersViolationsRow: React.FC<Props> = ({ flags, user, onClick }) => {
  const totalCnt = restrictionsCount(user);

  console.log(user);

  return (
    <div
      className="uv-table__row"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick?.()}
    >
      <div className="uv-table__cell">
        <div className="uv-table__main">{user.name || user.username || 'Unknown'}</div>
        <div className="uv-table__sub">{formatUsername(user)}</div>
      </div>

      <div className="uv-table__cell">
        <div className="uv-table__main">{user.email || '—'}</div>
      </div>

      <div className="uv-table__cell">
        <div className="uv-table__main">{user.id}</div>
      </div>

      <div className="uv-table__cell">
        {totalCnt > 0 ? (
          <div className="uv-table__badges">
            {(user.restrictions ?? []).slice(0, 4).map((r) => (
              <span className="uv-table__badge" key={r.restriction}>
                {flags ? decodeRestrictionValue(r.restriction, flags.data) : null}
              </span>
            ))}
          </div>
        ) : (
          <div className="uv-table__sub">—</div>
        )}
      </div>

      <div className="uv-table__cell">
        <div className="uv-table__main">{user.register_at || '—'}</div>
        <div className="uv-table__sub">last: {user.last_login || '—'}</div>
      </div>

      <div className="uv-table__cell">
        <Link className="uv-table__open" to={`${base}/user/violations/${user.id}`}>
          Open
        </Link>
      </div>
    </div>
  );
};
